export const claimsList = ({ caseClaims: { data = [] } }) => data;

export const claimsCount = ({ caseClaims: { count = [] } }) => count;

export const claimsStatuses = ({ caseClaims: { statuses = [] } }) => statuses;

export const claimsDebtors = ({ caseClaims: { debtors = [] } }) => debtors;



// WEBPACK FOOTER //
// ./src/store/selectors/caseClaims.js